import React from "react"
import { FormFeedback as ReactstrapFormFeedback, FormFeedbackProps } from "reactstrap"

export const FormFeedback: React.FC<FormFeedbackProps> = props => {
  return <ReactstrapFormFeedback {...props} />
}

export default FormFeedback
